/**
 * Which paths differ between two versions of the config.
 *
 * Mirrors helpers/plans-config.diff.ts on the backend so the save bar, the
 * publish dialog and the stored history all describe a change the same way.
 */
const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const changedPaths = (before, after, prefix = '') => {
    if (before === after) return [];

    if (isPlainObject(before) && isPlainObject(after)) {
        const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
        return [...keys].flatMap((key) =>
            changedPaths(before[key], after[key], prefix ? `${prefix}.${key}` : key),
        );
    }

    if (Array.isArray(before) && Array.isArray(after)) {
        if (before.length !== after.length) return [prefix];
        return before.flatMap((item, index) => changedPaths(item, after[index], `${prefix}[${index}]`));
    }

    return JSON.stringify(before) === JSON.stringify(after) ? [] : [prefix];
};

export default changedPaths;
